// src/env.ts
// CRA (react-scripts) ersetzt process.env.REACT_APP_* statisch zur Build-Zeit.
// Dynamischer Zugriff (process.env[variable]) funktioniert im Browser nicht.
export const ENV = {
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL ?? "",
  ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ?? "",
  FUNCTION_ENDPOINT: process.env.REACT_APP_FUNCTION_ENDPOINT ?? "",
};